<template>
	<v-app :class="isMobile">
		<v-main	>
			<v-overlay v-model="overlay"
			opacity="1"
			class="video-overlay"
			scrim="#fff"
			style="background-color: white;"
			:ripple="false"
			>
			<!-- <video autoplay muted loop id="introVideo">
				<source :src="require('@/assets/video/loader.mp4')" type="video/mp4"
					style="width: 100%; height: 100%; object-fit: cover; position: absolute; top: 0; left: 0; z-index: -1;"
				>
			</video> -->
			<!-- Use GIf instead of video -->
				<img class="loaderGif" :src="require('@/assets/video/loader_v5.gif')" alt="loading" >
			</v-overlay>
			<more-info-holder :isOpen="showMoreInfo" />
			<div ref="sceneContainer" style="width: 100%; height: 100%;"></div>
			<search-button @selectedCountry="selectedCountry" />
			<movement-focus-button />
			<globe-foot-bar class="globe-foot-bar-component" @zoom="handleZoom"/>
		</v-main>
	</v-app>
</template>


<script lang="ts">
import { defineComponent, ref, onMounted, Ref, computed, watch } from 'vue';
import * as THREE from 'three';
import * as TWEEN from '@tweenjs/tween.js';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader';
// import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { CustomGlobeControls } from './plugins/customGlobeControls';
import '@/assets/fonts/stylesheet.css';

import { Service as CountryService } from './services/countryService';

import store from '@/store';

import {getStaticResourcesPath, storeTooltipData} from './services/dataHandlerService';

export default defineComponent(
{
	name: 'GlobeComponent',
	setup()
	{
		const sceneContainer = ref<HTMLDivElement | null>(null);
		const showMoreInfo = ref(false);
		const customGlobeControls = ref<CustomGlobeControls | null>(null);
		let globe: THREE.Group;
		const animationDuration = 500;
		const modalAnimationSpeedMod = 0.6;
		const colorReturnTransMod = 0.5;
		const isMobile = window.innerWidth <= 900;

		let modalMode = computed(() => store.getters['stateStoreData/modalMode']);

		let overlay = ref(true); 

		const riskMapColours = [
			{ risk: 'Low', color: 0x91be63 },
			{ risk: 'Moderate Low', color: 0xbddcb1 },
			{ risk: 'Moderate', color: 0xffe04e },
			{ risk: 'Moderate High', color: 0xe6a721 },
			{ risk: 'High', color: 0xe11212 },
			{ risk: 'Very High', color: 0xa70d28 }
		];

		let camera: Ref<THREE.PerspectiveCamera> = ref(new THREE.PerspectiveCamera(75, 1, 100, 1000));

			const initThreeJS = () => {
				const container = sceneContainer.value;			

				if (!container) {
					console.error("Container element not found");
					return;
				}

				// Create scene
				const scene = new THREE.Scene();

				// Load background image
				const textureLoader = new THREE.TextureLoader();
				textureLoader.load( getStaticResourcesPath()+ 'Background-Studio.png', (texture) => {
					scene.background = texture;
				});

				// Create camera and zoom out
				camera.value = new THREE.PerspectiveCamera(75, container.clientWidth / container.clientHeight, 0.1, 1000);
				camera.value.position.set(0, 0, 2.5);

				// Create renderer
				const renderer = new THREE.WebGLRenderer({ 
					antialias: true, 
					alpha: true,
					preserveDrawingBuffer: true,
					powerPreference: 'high-performance',
					precision: 'mediump'
				});
				renderer.setSize(container.clientWidth, container.clientHeight);
				renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
				renderer.shadowMap.enabled = true;
				container.appendChild(renderer.domElement);

	console.log('--------------- renderer -----------------');
	console.dir(renderer, {depth: 2});
	console.log('--------------------------------');

				// Add lights
				const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
				scene.add(ambientLight);

				const hemisphereLight = new THREE.HemisphereLight(0xffffff, 0x080820, 0.75);
				scene.add(hemisphereLight);

				const directionalLight = new THREE.DirectionalLight(0xFDF5E6, 1);
				directionalLight.position.set(1, 1, 1).normalize();
				directionalLight.castShadow = true;
				directionalLight.intensity = 2;
				scene.add(directionalLight);

				let bumpMapTexture = textureLoader.load(getStaticResourcesPath() + 'bumpmap-3500px.jpg');

				if(isMobile){
					bumpMapTexture = textureLoader.load(getStaticResourcesPath() + 'bumpmap-3500px.jpg');
				}
				
				let rotationSpeed = -0.0002;
				let currentRotationSpeed = rotationSpeed;
				let autoRotate = true;

			//	 const loadFBXModel = () => {
			//	 const loader = new FBXLoader();
			//	 loader.load(getStaticResourcesPath() + '/globe-v39.fbx', (object) => {
			//		 globe = new THREE.Group();
			//		 object.traverse((child) => {
			//			 if ((child as THREE.Mesh).isMesh) {
			//				 let mesh = child as THREE.Mesh;
			//				 mesh.updateMatrix();
			//				 let geometry = mesh.geometry.clone();
			//				 geometry.applyMatrix4(mesh.matrix);
			//				 let material;
			//				 if (child.name == 'sea' || child.name == 'Sphere') {
			//					 material = new THREE.MeshStandardMaterial({
			//						 color: 0xffffff,
			//					 });
			//				 } else {
			//					 const countryData = CountryService.getCountryByObjectCode(child.name);
			//					 material = new THREE.MeshStandardMaterial({
			//						 color: countryData ? countryData.riskCategoryObject.color : 0xffffff,
			//						 bumpMap: bumpMapTexture,
			//						 bumpScale: 10,
			//					 });
			//					 material.needsUpdate = true;
			//				 }

			//				 let country = new THREE.Mesh(geometry, material);
			//				 country.name = child.name;
			//				 country.castShadow = true;
			//				 country.receiveShadow = true;
			//				 globe.add(country);

			//				 // Create and add outline only at the borders
			//				 if (child.name !== 'Sphere') {
			//						 const outlineGeometry = new THREE.EdgesGeometry(geometry, 50); // Threshold parameter to adjust edge detection
			//						 const outlineMaterial = new THREE.LineBasicMaterial({ color: 0xE2DFDB, linewidth: 1, opacity: 1, transparent: true});
			//						 const outline = new THREE.LineSegments(outlineGeometry, outlineMaterial);
			//						 outline.renderOrder = 1; // Ensure it renders on top
			//						 outline.raycast = () => {
			//							 // Prevent raycasting on the outline
			//						 };
			//						 globe.add(outline);
			//					 }
			//			 }
			//		 });
			//		 scene.add(globe);
			//		 finishLoading();
			//	 }, undefined, (error) => {
			//		 console.error('An error happened while loading FBX', error);
			//	 });
			// };

			// const loadGLTFModel = (version: number) => {
			//	 let globeFile = '/globe-v' + version + '.glb';
			//	 const loader = new GLTFLoader();
			//	 loader.load(getStaticResourcesPath() + globeFile, (gltf) => {
			//		 globe = new THREE.Group();
			//		 gltf.scene.traverse((child) => {
			//			 if ((child as THREE.Mesh).isMesh) {
			//				 let mesh = child as THREE.Mesh;
			//				 mesh.updateMatrix();
			//				 let geometry = mesh.geometry.clone();
			//				 geometry.applyMatrix4(mesh.matrix);
			//				 let material;
			//				 if (child.name == 'sea' || child.name == 'Sphere') {
			//					 material = new THREE.MeshStandardMaterial({
			//						 color: 0xffffff,
			//					 });
			//				 } else {
			//					 const countryData = CountryService.getCountryByObjectCode(child.name);
			//					 material = new THREE.MeshStandardMaterial({
			//						 color: countryData ? countryData.riskCategoryObject.color : 0xffffff,
			//						 bumpMap: bumpMapTexture,
			//						 bumpScale: 10,
			//					 });
			//					 material.needsUpdate = true;
			//				 }

			//				 let country = new THREE.Mesh(geometry, material);
			//				 country.name = child.name;
			//				 country.castShadow = true;
			//				 country.receiveShadow = true;
			//				 globe.add(country);

			//				 // Create and add outline only at the borders
			//				 if (child.name !== 'Sphere') {
			//						 const outlineGeometry = new THREE.EdgesGeometry(geometry, 180); // Threshold parameter to adjust edge detection
			//						 const outlineMaterial = new THREE.LineBasicMaterial({ color: 0xE2DFDB, linewidth: 1, opacity: 1, transparent: true});
			//						 const outline = new THREE.LineSegments(outlineGeometry, outlineMaterial);
			//						 outline.renderOrder = 1; // Ensure it renders on top
			//						 outline.raycast = () => {
			//							 // Prevent raycasting on the outline
			//						 };
			//						 globe.add(outline);
			//					 }
			//			 }
			//		 });
			//		 scene.add(globe);
			//		 finishLoading();
			//	 }, undefined, (error) => {
			//		 console.error('An error happened while loading GLTF', error);
			//	 });
			// };

				const mtlLoader = new MTLLoader();
				// mtlLoader.load( getStaticResourcesPath() +	'globe-v26.mtl', (materials) => {
				//	 materials.preload();

				const loadOBJModel = (version: number) => {
					let globeFile = '/globe-v' + version + '.obj';
					const loader = new OBJLoader();
					// loader.setMaterials(materials);
					loader.load(getStaticResourcesPath() + globeFile, (object) => {
						globe = new THREE.Group();
						object.traverse((child) => {

			//if (child.name == 'FR' || child.name == 'ES' || child.name == 'sea') {

							if ((child as THREE.Mesh).isMesh)
							{
								let mesh = child as THREE.Mesh;
								mesh.updateMatrix();
								let geometry = mesh.geometry.clone();
								geometry.applyMatrix4(mesh.matrix);
								let material;
								if (child.name == 'sea')
								{
									material = new THREE.MeshStandardMaterial({
										color: 0xffffff,
									});
								}
								else
								{	
									const countryData = CountryService.getCountryByObjectCode(child.name);
									material = new THREE.MeshStandardMaterial({
										color: countryData ? countryData.riskCategoryObject.color : 0xffffff,
										bumpMap: bumpMapTexture,
										bumpScale: 10,
									});
								
									// Ensure the material has UV mapping
									material.needsUpdate = true;
								}

								let country = new THREE.Mesh(geometry, material);
								country.name = child.name;
								country.castShadow = true;
								country.receiveShadow = true;
					
								globe.add(country);

								// Create and add outline only at the borders
								if (child.name !== 'sea')
								{
									const outlineGeometry = new THREE.EdgesGeometry(geometry, 50); // Threshold parameter to adjust edge detection
									const outlineMaterial = new THREE.LineBasicMaterial({ color: 0xE2DFDB, linewidth: 1, opacity: 1, transparent: true});
									const outline = new THREE.LineSegments(outlineGeometry, outlineMaterial);
									outline.renderOrder = 1; // Ensure it renders on top
									outline.raycast = () => {
										// Prevent raycasting on the outline
									};
									globe.add(outline);
								}
							}
						});
						scene.add(globe);

						overlay.value=false;

						let defaultGlobePosition = new THREE.Vector3(0, 0, 0);
						defaultGlobePosition = new THREE.Vector3(0.75, 0, 0);
						customGlobeControls.value = new CustomGlobeControls(globe, camera.value, renderer.domElement, defaultGlobePosition,isMobile);
						customGlobeControls.value.dragSpeed = 0.06;

						return customGlobeControls.value;

					}, undefined, (error) => {
						console.error('An error happened', error);
					});
				};

				let version = 57;

				// loadGLTFModel(version);
				loadOBJModel(version);

			//	 const finishLoading = () => {
			//	 overlay.value = false;
			//	 let defaultGlobePosition = new THREE.Vector3(0.75, 0, 0);
			//	 customGlobeControls.value = new CustomGlobeControls(globe, camera.value, renderer.domElement, defaultGlobePosition, isMobile);
			//	 customGlobeControls.value.dragSpeed = 0.06;
			// };


				renderer.shadowMap.enabled = true;

				// let shadowGeometry = new THREE.PlaneGeometry(200, 200);

				// let shadowMaterial = new THREE.MeshPhongMaterial({
				//	 color: 0xFFFFFF,
				//	 transparent: true,
				//	 opacity: 0,
				// })

				// let shadowPlane = new THREE.Mesh(shadowGeometry, shadowMaterial);
				// shadowPlane.position.y = -2;
				// shadowPlane.rotateX(- Math.PI / 2);
				// // shadowPlane.receiveShadow = true;

				// Create a canvas and draw a radial gradient on it
				let canvas = document.createElement('canvas');

				canvas.width = 128;
				canvas.height = 128;

				let context = canvas.getContext('2d');

				if (!context)
				{
					console.error('Could not get 2d context');
					return;
				}
				let gradient = context.createRadialGradient(
					canvas.width / 2,
					canvas.height / 2,
					0,
					canvas.width / 2,
					canvas.height / 2,
					canvas.width / 2
				);
				gradient.addColorStop(0.1, 'rgba(0,0,0,0.6)');
				gradient.addColorStop(1, 'rgba(0,0,0,0)');

				context.fillStyle = gradient;
				context.fillRect(0, 0, canvas.width, canvas.height);

				// Create a texture from the canvas
				let shadowTexture = new THREE.Texture(canvas);
				shadowTexture.needsUpdate = true;

				// Create a material with the texture
				let shadowMaterial = new THREE.MeshBasicMaterial({
					map: shadowTexture,
					transparent: true,
					depthWrite: false,
				});

				// Create a plane geometry
				let shadowGeometry = new THREE.PlaneGeometry(2.2, 2.2);

				// Create a mesh with the geometry and material
				let shadowPlane = new THREE.Mesh(shadowGeometry, shadowMaterial);
				shadowPlane.position.y = -1.5;
				shadowPlane.rotateX(- Math.PI / 2);

				// Add the mesh to the scene
				scene.add(shadowPlane);

				directionalLight.castShadow = true;
				directionalLight.shadow.mapSize.width = 4096;
				directionalLight.shadow.mapSize.height = 4096;
				// TODO 50 worst case scenario
				directionalLight.shadow.radius = 100;

				const onWindowResize = () => {
					if (!camera.value) return;
					camera.value.aspect = container.clientWidth / container.clientHeight;
					camera.value.updateProjectionMatrix();
					renderer.setSize(container.clientWidth, container.clientHeight);
				};

				window.addEventListener('resize', onWindowResize);

				let raycaster = new THREE.Raycaster();
				let mouse = new THREE.Vector2();
				let mouseDown = new THREE.Vector2();
				let mouseUp = new THREE.Vector2();

				function onMouseDown(event: MouseEvent)
				{
					if (event.target !== renderer.domElement)
					{
						return;
					}

					mouseDown.x = event.clientX;
					mouseDown.y = event.clientY;
				}

				function onMouseUp(event: MouseEvent)
				{
					if (event.target !== renderer.domElement)
					{
						return;
					}

					mouseUp.x = event.clientX;
					mouseUp.y = event.clientY;

					if (Math.abs(mouseUp.x - mouseDown.x) < 5 && Math.abs(mouseUp.y - mouseDown.y) < 5)
					{
						mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
						mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

						raycaster.setFromCamera(mouse, camera.value);

						let intersects = raycaster.intersectObjects(globe.children, true)

						if (intersects.length > 0) {
							if (intersects[0].object.name !== 'sea' && intersects[0].object.name !== '') {
								countryClick(intersects[0].object as THREE.Mesh);
							}
						}
					}
				}

				window.addEventListener('mousedown', onMouseDown, false);
				window.addEventListener('mouseup', onMouseUp, false);

				const animate = () => {

					requestAnimationFrame( animate );

					TWEEN.update();
					autoRotate = false;
					if (globe && autoRotate)
					{
						let axis = new THREE.Vector3(0, 1, 1);
						let angle = currentRotationSpeed;
						globe.rotateOnWorldAxis(axis, angle);
					}
					renderer.render(scene, camera.value);
				};

				animate();

				return () => {
					window.removeEventListener('resize', onWindowResize);
					window.removeEventListener('mousedown', onMouseDown);
					window.removeEventListener('mouseup', onMouseUp);
				};
			};

			const selectedCountry = (country: any) => {
			
			globe.children.forEach((child) => {
				if (child instanceof THREE.Mesh)
				{
					if (child.name === country)
					{
						countryClick(child);
					}
				}
			});
				
			};

			const countryClick = (country: THREE.Mesh) => {
			
				if (!country) return;
				if(country.name == 'Sea') return; // Added by Laurence C. prevent sea opening an empty modal
				if (!globe) return;

				console.log('Country clicked:', country);
			
				if (customGlobeControls.value) {
					customGlobeControls.value.centerCameraOnObject(country, animationDuration);
				}

				globe.children.forEach((child) => {
					if (child instanceof THREE.Mesh)
					{
						if (!child.userData.originalColor)
						{
							child.userData.originalColor = child.material.color.getHex();
						}
						if (child === country)
						{
							child.material.color.set(child.userData.originalColor);
						}
						else
						{
							const originalColor = child.userData.originalColor ? new THREE.Color(child.userData.originalColor) : child.material.color;
							const average = originalColor.r + originalColor.g + originalColor.b / 3;
							const greyscaleRGB = new THREE.Color(average, average, average);

							new TWEEN.Tween(child.material.color)
								.to(greyscaleRGB, animationDuration)
								.start();
						}
					}
				});

				setTimeout(() => {
					const countryData : any = CountryService.getCountryByObjectCode(country.name);
					store.dispatch("countryStoreData/setSelectedCountry", countryData);
					showMoreInfo.value = true;
					store.dispatch('stateStoreData/setModalMode', 'data');
				}, animationDuration * modalAnimationSpeedMod);
			};

			const setCountryColors = () => {
				globe.children.forEach((child) => {
					if (child instanceof THREE.Mesh) {
						if (!child.userData.originalColor) {
							child.userData.originalColor = child.material.color.getHex();
						}

						const originalColor = new THREE.Color(child.userData.originalColor);

						new TWEEN.Tween(child.material.color)
							.to(originalColor, animationDuration * colorReturnTransMod)
							.start();
					}
				});
			};

			const resetCameraZoom = () => {
				if (customGlobeControls.value) {
					customGlobeControls.value.animateCameraZoomReset(animationDuration);
				}
			}

			onMounted(() => {
				storeTooltipData();
				CountryService.setAllCountries().then(() => {
					// initThreeJS();
					setTimeout(initThreeJS, 0);
				})

				// overlay.value = false;
				
				// setTimeout(() => {
				//		 overlay.value = false;
				// }, 7000);

			});


			watch(modalMode, (newVal) => {
			if (newVal == null) {
				setCountryColors();
				resetCameraZoom();
			}
		});

		watch(() => store.getters['countryStoreData/selectedCountry'], (newVal) => {
			if (newVal) {
				selectedCountry(newVal);
			}
		});

		return {
			sceneContainer,
			camera,
			countryClick,
			customGlobeControls,
			showMoreInfo,
			selectedCountry, // Ensure selectedCountry is returned
			isMobile,
			overlay,

		};
	},
	data() {
		return {
			zoomTransition: 0,
			targetZoom: 0,
		};
	},
	methods: {
		handleZoom(zoomFactor: number) {
			this.targetZoom = this.camera.zoom * zoomFactor;
			const zoomStep = (this.targetZoom - this.camera.zoom) / 15;
			if (this.zoomTransition) {
				clearInterval(this.zoomTransition);
			}
			
			(this.zoomTransition as any) = setInterval(() => {
				if (Math.abs(this.camera.zoom - this.targetZoom) < Math.abs(zoomStep)) {
					this.camera.zoom = this.targetZoom;
					clearInterval(this.zoomTransition);
					this.zoomTransition = 0;
				} else {
					this.camera.zoom += zoomStep;
				}
				this.camera.updateProjectionMatrix();
			}, 20);
		},
	},
});
</script>

<style scoped>
.app {
	position: relative;
}
.loaderGif{
	/* width: 100%; */
		/* margin-top: 10%; */
}
.globe-foot-bar-component {
	position: absolute;
	bottom: 2%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
}


#introVideo{
	width: 100%;
		margin: auto;
		display: block;
}

.video-overlay{
	width: 100%;
	z-index: 1000000;
}

/* mobile */
@media only screen and (max-width: 900px) {
	#introVideo{
		width: 200%;
		margin: 20% -50%;
	}

	.loaderGif{
		/*margin-top: 50%;
		margin-left: -10px; */
		width: 100%;
	}

	.globe-foot-bar-component{
		position: fixed;
		top: inherit;
		bottom: 30px;
		/* left:10px; */
	}
}


</style>

<style>
body {
		touch-action: manipulation;
		zoom: 1;
}

canvas
{
	width: 100vw!important;
}

.scroll-container {
	overflow: auto; /* Ensure scrollbar only appears when needed */
	max-height: 100%; /* Adjust as needed */
}

.scroll-container::-webkit-scrollbar-track {
	background: #940505;
	border-radius: 10px;
}

.scroll-container::-webkit-scrollbar-thumb {
	background: #b41313;
	border-radius: 10px;
}

.scroll-container::-webkit-scrollbar-thumb:hover {
	background: #d32525;
}

.scroll-container::-webkit-scrollbar {
	display: none;
}

.scroll-container {
	-ms-overflow-style: none;	/* IE and Edge */
	scrollbar-width: none;	/* Firefox */
}

.video-overlay .v-overlay__content{
	display: block;
		margin: auto;
		width: 560px;
		position: relative;
}


.buttonBranding_midnight:hover {
		background: #3C424C !important;	 
}

.buttonBranding_midnight:active {
		color: #9DA3AE;
		background: #333333 !important;
}

.buttonBranding_midnight:disable {
		background: #E7E9EE !important;
		color: #9DA3AE;
}

.buttonBranding_midnight:focus {
		border:2px solid #5971F2;
		background-color: #333 !important;
		padding: 23px 22px	!important;
}

.circularBranding_iconButton{

}

.iconButton_midnight:hover{
	background-color: #3C424C !important;
}

.iconButton_midnight:active{
	background-color: #333333 !important;
	color: #9DA3AE !important;
	border: none;
}

.iconButton_midnight:focus{
	border:2px solid #5971F2;
	background-color: #333 !important;
}


.iconButton_light:hover{
	background: white !important;
}

.iconButton_light:active{
	/* no change needed */
	background-color: #E7E9EE !important;
}

.iconButton_light:focus{
	border:2px solid #5971F2;
	background-color: #E7E9EE !important;
}

</style>

